import 'css-chunk:src/feature/check-item/CheckItemEditActions.module.scss';export default {
  "root": "CheckItemEditActions_root",
  "itemPositionActions": "CheckItemEditActions_itemPositionActions",
  "itemActions": "CheckItemEditActions_itemActions",
  "cta": "CheckItemEditActions_cta"
};